import { generateClient } from 'aws-amplify/data';
import type { Schema } from '../amplify/data/resource';

/** Zentraler Data-Client (userPool-Auth). */
export const client = generateClient<Schema>();
